//import DailyPrescribeDataFunc from "@/pcomponents/common/content/edu/daily_prescribe/func/data_func";

class DailyPrescribeDataFunc
{
  static default_info:any={
    a_ymd:"",
    a_seq:"",
    a_write_date:"",
    a_stu_seq:"",
    a_stu_name:"",
    a_writer_seq:"",
    a_writer_name:"",
    a_subject:"",
    a_issue:"",
    a_homework_plan:"",
    a_homework_amount:"",
    a_progress_plan:"",
    a_progress_amount:"",
    a_memo:"",
  };
}
export default DailyPrescribeDataFunc;